export default "__VITE_ASSET__BPkRMR0a__"